import client from './client';

export default {
  create(params) {
    return client.post('/appointments/create_free_standing_appointment')
      .send(params)
      .end();
  }
};



// WEBPACK FOOTER //
// ./app/sources/api/freeStandingAppointment.js